import { useMutation,  } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useSyncStrapi = () => {
  const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
  return useMutation({
    mutationFn: async () => {
      const result = await restClient({
        url: `${prefix}/crm/sync`,
        method: 'POST'
      });
      return result;
    },
    onSuccess: () => {
    }
  });
};